import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { HighlightTextModule, NavButtonModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { SearchProductsComponent } from './search-products.component';
import { SuffixLabelPipe } from './suffix-label.pipe';

@NgModule({
  declarations: [SearchProductsComponent, SuffixLabelPipe],
  imports: [CommonModule, TranslationModule, NavButtonModule, HighlightTextModule, AnalyticsModule],
  exports: [SearchProductsComponent]
})
export class SearchProductsModule {}
